<template>
    <div :class="['block-wrapper', size, type]">
        <div class="header-n-content">
            <div class="header">
                <h3 v-if="title" class="title" :style="titleStyle">
                    {{ title }}
                </h3>
            </div>
            <div class="content">
                <slot />
            </div>
        </div>
        <div class="actions" v-if="onEdit">
            <div v-if="enableEdit" style="margin-left: 10px">
                <div v-if="isEditMode">
                    <el-button size="mini" type="" @click="onCancel">
                        <i class="el-icon-close"></i>
                    </el-button>
                    <el-button size="mini" type="primary" @click="onSave">
                        <i class="el-icon-check"></i>
                    </el-button>
                </div>
                <div v-else>
                    <el-button size="mini" type="primary" plain @click="onEdit">
                        <i class="el-icon-edit"></i>
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'primary',
        },
        title: {
            type: String,
            default: null,
        },
        titleStyle: {
            type: String,
            default: null,
        },
        onEdit: {
            type: Function,
            default: undefined,
        },
        onSave: {
            type: Function,
            default: () => {},
        },
        onCancel: {
            type: Function,
            default: () => {},
        },
        size: {
            type: String,
            default: 'normal',
        },
        isEditMode: Boolean,
        enableEdit: Boolean,
    },
    computed: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.block-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px;
    border-radius: 7px;

    @media (max-width: 720px) {
        display: block;
    }

    &.primary {
        background: #f7f7fa;
        .title {
            color: $main-color;
        }
    }
    &.error {
        background: #ffe8e8;
        .title {
            color: #f00;
        }
    }

    &.small {
        padding: 5px 0;
        border-radius: 10px;
        background-color: transparent;
        justify-content: flex-start;

        > .header-n-content {
            > .header {
                > .title {
                    font-size: 10pt;
                    margin-left: 0;
                }
            }

            > .content {
                font-size: 10pt;
            }
        }
    }

    .header-n-content {
        flex-grow: 1;

        &.flex {
            display: flex;
        }

        @media (max-width: 720px) {
            display: block;
        }
    }

    .title {
        margin-bottom: 0;
        margin-left: 0px;
        margin-right: 30px;
    }
}
</style>
